export default "https://cdn-static.gokick.com/assets/afaaccc9c40207d12945800ee9a4df41e308a977/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";